import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-6b90830d")
const _hoisted_1 = { class: "container mx-auto" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "sunrise-name mt-[34px]" }
const _hoisted_4 = { class: "sunrise-description mt-[12px] p-[10px]" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Stake your $SPOLAR to earn ")
const _hoisted_6 = { class: "uppercase" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", { class: "view-and-stake mt-[34px]" }, "View and Stake", -1)
_popScopeId()

import { computed, onMounted, ref } from 'vue';
import useBreakpoints from '@/composables/useBreakpoints';
import SunrisePageHero from '@/components/heros/SunrisePageHero.vue';
import polarImg from './polar.svg';
import orbitalImg from './orbital.svg';
import uspImg from './usp.svg';
import ethernalImg from './ethernal.svg';
import binarisImg from './binaris.svg';
import tripolarImg from './tripolar.svg';
import { sunriseDefinitions } from './config';


export default _defineComponent({
  setup(__props) {

const logo = {
  polar: polarImg,
  orbital: orbitalImg,
  usp: uspImg,
  ethernal: ethernalImg,
  binaris: binarisImg,
  tripolar: tripolarImg,
};

const { isMobile, isDesktop } = useBreakpoints();

const sunrises = computed(() =>
  Object.values(sunriseDefinitions).filter(sunrise => !sunrise.retired)
);

onMounted(() => {});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SunrisePageHero),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["grid gap-6 ", {'grid-cols-3':_unref(isDesktop),'grid-cols-1':_unref(isMobile)}])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sunrises), (sunrise, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            key: idx,
            class: _normalizeClass({ sunriseCard: _unref(isDesktop), sunriseCardMobile: _unref(isMobile) })
          }, [
            _createElementVNode("img", {
              src: logo[sunrise.name],
              class: "logo"
            }, null, 8, _hoisted_2),
            _createElementVNode("div", _hoisted_3, _toDisplayString(sunrise.name), 1),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", null, [
                _hoisted_5,
                _createElementVNode("span", _hoisted_6, _toDisplayString('$' + sunrise.name), 1)
              ])
            ]),
            _createVNode(_component_router_link, {
              to: '/sunrise/' + sunrise.name
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 2
            }, 1032, ["to"])
          ], 2))
        }), 128))
      ], 2)
    ])
  ], 64))
}
}

})